import { format } from 'date-fns';

export const formatDate = (dateTime: number, formatToReturn = 'ddMMyyyy') => format(new Date(dateTime), formatToReturn);
